import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import RightChevron from '../../themes/wls/icons/rightChevron'
import LeftChevron from '../../themes/wls/icons/leftChevron'
import Link from '../../themes/wls/icons/link'
import Close from '../../themes/wls/icons/close'

const icons = {
  rightChevron: RightChevron,
  leftChevron: LeftChevron,
  link: Link,
  close: Close
};

const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: ${(props) => props.colour || props.theme.colours.black};
  user-select: none;
`;
const Image = styled.img`
  height: 100%;
  width: 100%;
`;

const Icon = ({ brand, name, theme, ...props }) => {
  if (brand==="wls") {
    const Component = icons[name];
    return <Component />;
  }

  return (
    <Container {...props}>
      {theme.icons[name] && (
        <Image src={theme.icons[name]} alt={`${name} icon`} />
    )}
    </Container>
  )
};

Icon.propTypes = {
  name: PropTypes.string,
  theme: PropTypes.instanceOf(Object),
  brand: PropTypes.oneOf(['ngn', 'tnl', 'tnl_com' ,'wls', 'tls', 'tls_com'])

};
Icon.defaultProps = {
  name: '',
  theme: {},
  brand:""
};

export default withTheme(Icon);
